import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from '../models';
import { CrudBaseService } from '../crud.service';
import { Observable } from 'rxjs';
import { UserReset } from '@modules/user/models/user.model';

@Injectable()
export class UserService extends CrudBaseService<User> {
    constructor(httpClient: HttpClient) {
        super('/user', httpClient);
    }

    resetForce(userId: string, model: UserReset): Observable<any> {
        return this.httpClient.post(this.basePath + `/${userId}/reset_force`, {
            data: model,
        });
    }

    resendVerify(userId: string): Observable<any> {
        return this.httpClient.get(this.apiBasePath + `/resend_verify/${userId}`);
    }
}
